import React from "react";
import "./adeed-brand.scss";
import AdeedWordmarkDark from "../../assets/images/adeed-wordmark-dark.png";
import AdeedWordmarkLight from "../../assets/images/adeed-wordmark-light.png";
import TrukkerLogoInk from "../../assets/images/trukker-logo-ink.png";
import TrukkerLogoLight from "../../assets/images/trukker-logo-light.png";
import { useIsDarkMode } from "../theme-mode/theme-mode";

// The ADEED Freight lock-up, as the ADEED portal draws it (procureco src/components/ui/Logo.jsx, AdeedLogo):
// the ADEED wordmark, a hairline, FREIGHT in the brand blue, and "powered by TruKKer" beneath.
// `dark` describes the SURFACE: on a dark surface the light (white) artwork is used. Left out, it follows the
// light/dark mode (Settings > Appearance), as the portal's logo does.
// `height` is the lock-up's nominal height; the wordmark is 60% of it and everything else scales from it.
const AdeedLogo = ({ dark: onDark, height = 36, endorsed = true, className = "" }) => {
  const isDarkMode = useIsDarkMode();
  const dark = onDark ?? isDarkMode;
  const wordmarkHeight = Math.round(height * 0.6);
  return (
    <div className={`adeed-logo ${dark ? "adeed-logo--dark" : ""} ${className}`}>
      <span className="adeed-logo__lockup" style={{ gap: Math.round(wordmarkHeight * 0.32) }} role="img" aria-label="ADEED Freight">
        <img src={dark ? AdeedWordmarkLight : AdeedWordmarkDark} alt="" style={{ height: wordmarkHeight }} draggable={false} />
        <span aria-hidden="true" className="adeed-logo__rule" style={{ minHeight: wordmarkHeight }} />
        <span aria-hidden="true" className="adeed-logo__freight" style={{ fontSize: Math.round(wordmarkHeight * 0.52) }}>
          Freight
        </span>
      </span>
      {endorsed && (
        <span className="adeed-logo__endorsement">
          powered by
          <img src={dark ? TrukkerLogoLight : TrukkerLogoInk} alt="TruKKer" draggable={false} />
        </span>
      )}
    </div>
  );
};

export default AdeedLogo;
